<template>
  <div class="add-funds-coinbase">
    <account-form-loader v-if="!isComponentReady" theme="deposit"></account-form-loader>
    <account-upload-document
      v-else-if="documentUploadInfoVisible"
      :source="documentUploadSource"
      :isPending="documentUploadInfoPending"
      theme="page-padded"
    ></account-upload-document>
    <account-ssn-info-upload v-else-if="collectSsnInfo"> </account-ssn-info-upload>
    <template v-else>
      <fee-waived-banner
        class="add-funds-coinbase__alert-box"
        level="success"
        :text="promoCodeDetail.friendlyDescription"
        v-if="showPromoNotification && false"
      >
      </fee-waived-banner>
      <fee-waived-banner
        :level="instantCreditBoxLevel"
        :text="instantCreditBoxMessage"
        v-if="showInstantCreditNotification && false"
      >
      </fee-waived-banner>
      <div v-if="depositWarning" v-html="depositWarning" class="predictit-embedded-alert"></div>
      <alert-box v-if="errorMessage" class="add-funds-coinbase__alert-box" level="warning">
        <div v-html="errorMessage"></div>
      </alert-box>
      <template v-else>
        <form @submit.prevent="onSubmit" class="add-funds-coinbase__form">
          <h5 class="add-funds-coinbase__title">
            Deposit (${{ minimumDepositAmount.toFixed(2) }} Minimum)
          </h5>
          <deposit-amount-picker
            v-model="fields.amount"
            :deposit-amounts="depositAmounts"
            :has-error="amountHasError"
            :error-message="amountValidationMessage"
            @add="onUpdateAmount"
            @blur="handleAmountBlur"
            @input="$v.fields.amount.$touch"
          ></deposit-amount-picker>
          <p class="add-funds-coinbase__note">
            You can deposit funds into your PredictIt account using a
            <a href="https://www.coinbase.com/usdc" v-outer-link>USD Coin</a> wallet. After clicking
            on the Confirm button below, you will be taken to Coinbase to complete your transaction.
          </p>
          <p class="add-funds-coinbase__note">
            Please note that <a href="https://www.coinbase.com" v-outer-link>Coinbase</a> charges a
            network fee to transfer funds. You should expect a delay between the time you transfer
            funds from your wallet and the time you receive a credit in your PredictIt account.
          </p>
          <div class="add-funds-coinbase__submit">
            <form-submit label="Confirm" :disabled="isConfirmDisabled"></form-submit>
          </div>
        </form>
        <template v-if="disclaimer">
          <br />
          <deposit-disclaimer :disclaimer="disclaimer"></deposit-disclaimer>
        </template>
      </template>
    </template>
  </div>
</template>

<script src="./add-funds-coinbase.js"></script>
<style src="./add-funds-coinbase.scss" lang="scss"></style>
